import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { AppMessagingService } from '../../../core/services/app-messaging.service';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import * as copy from 'copy-to-clipboard';
import { UserAgentDetection } from '../../../core/pure-functions/universal/user-agent-detection';
import { HttpParams } from '@angular/common/http';
import { AffiliateBannerConfig } from 'anchor-shared/lib/model/entity/affiliate';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-affiliate-link-copy',
  templateUrl: './affiliate-link-copy.component.html',
  styleUrls: ['./affiliate-link-copy.component.scss'],
})
export class AffiliateLinkCopyComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  @Input()
  affiliateBannerConfig: AffiliateBannerConfig;

  url: string;
  subs: Subscription[] = [];
  showCopyLink = true;
  showLinkSnippets = [
    '/home',
    '/vessels/yacht',
    '/vessels/boat',
    '/charters/yacht',
    '/charters/boat',
    '/rental-location-map',
  ];
  isMobile: boolean;

  constructor(
    private userDAO: UserDAO,
    private appMessagingService: AppMessagingService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.isMobile = window && window.screen && window.screen.width < 960;
  }

  ngOnInit() {
    this.initUrlCheck();
    this.subscribeToControlCopyLinkButtonVisibility();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  copyLinkClick(): void {
    this.url = window.location.href;
    if (this.url.includes('?')) {
      this.url = this.url.split('?')[0];
    }
    let params = new HttpParams();
    params = params.append('affiliate', this.affiliateBannerConfig.vanity);
    for (const key in this.route.snapshot.queryParams) {
      params = params.append(key, this.route.snapshot.queryParams[key]);
    }
    this.url = `${this.url}?${params.toString()}`;
    if (this.url) {
      if (UserAgentDetection.isMobileUserAgent(navigator.userAgent)) {
        this.shareNatively(this.url);
      } else {
        this.copyToClipboard(this.url);
      }
    }
  }

  private copyToClipboard(url: string): void {
    const success = copy(url);
    if (success) {
      this.appMessagingService.openSnack('Copied To Clipboard');
    }
  }

  private shareNatively(url: string): void {
    navigator['share']({ title: 'Anchor Yacht Rentals', text: url })
      .then(() => {
        console.log('completed share');
      })
      .catch((e) => {
        console.log(e);
      });
  }

  private subscribeToControlCopyLinkButtonVisibility(): void {
    const sub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(event);
        if (event.urlAfterRedirects) {
          let showLink = false;
          this.showLinkSnippets.forEach((link) => {
            if (
              this.urlPatternShouldShowCopyLink(event.urlAfterRedirects, link)
            ) {
              showLink = true;
            }
          });
          this.showCopyLink = showLink;
        }
      }
    });
    this.subs.push(sub);
  }

  private initUrlCheck(): void {
    let showLink = false;
    this.showLinkSnippets.forEach((link) => {
      if (this.urlPatternShouldShowCopyLink(this.router.url, link)) {
        showLink = true;
      }
    });
    this.showCopyLink = showLink;
  }

  private urlPatternShouldShowCopyLink(url: string, link: string): boolean {
    return url === '' || url === '/' || url.includes(link);
  }
}
